import React from "react";
import { useIntl } from "gatsby-plugin-react-intl";
import { navigate } from "gatsby";

import * as S from "./styled";

import Button from "../Button";

export default function Menu({ open, nameMenu, children }) {
  const intl = useIntl();

  let isDesktop;

  if (typeof window !== "undefined") {
    isDesktop = window.screen.width > 949;
  }

  return (
    <>
      {(() => {
        switch (nameMenu) {
          case "page-form-no-scape-no-back":
            return (
              <S.MenuWrapperNoScapeFormPage>
                {/* <S.GoBackNavLink onClick={() => navigate(-1)} /> */}
              </S.MenuWrapperNoScapeFormPage>
            );

          case "no-scape-partern-stack":
            return (
              <S.MenuWrapperNoScapePage open={open}>
                <S.BoxCtaDesktop>
                  <Button typeButton="scroll-to" goTo="#form">
                    {intl.formatMessage({ id: "navbar.btn" })}
                  </Button>
                </S.BoxCtaDesktop>

                <S.ContactWrapper>{children}</S.ContactWrapper>
              </S.MenuWrapperNoScapePage>
            );

          case "page-form-no-scape":
            return (
              <S.MenuWrapperNoScapeFormPage>
                <S.GoBackNavLink onClick={() => navigate("/")} />
              </S.MenuWrapperNoScapeFormPage>
            );

          case "thankyou-page":
            return (
              <S.MenuWrapperThankyouPage open={open}>
                <S.NavLink to="/">Ir para o site</S.NavLink>

                <S.NavLink to="/">Webinars</S.NavLink>
                <S.NavLink to="/">Relatórios</S.NavLink>

                <S.NavLink style={{ color: "var(--orange)" }} to="/">
                  Experimente Grátis
                </S.NavLink>

                <S.ContactWrapper>
                  <Button to="/contact/" typeButton="outline">
                    {intl.formatMessage({ id: "navbar.btn" })}
                  </Button>
                </S.ContactWrapper>
              </S.MenuWrapperThankyouPage>
            );

          default:
            return (
              <S.MenuWrapper open={open}>
                <S.NavLink
                  href={intl.formatMessage({ id: "navbar.link_why_axur" })}
                  target="_blank"
                >
                  {intl.formatMessage({ id: "navbar.why_axur" })}
                </S.NavLink>

                <S.ContactWrapper>
                  <S.GoBackNavLink onClick={() => navigate("/")} />
                </S.ContactWrapper>
              </S.MenuWrapper>
            );
        }
      })()}
    </>
  );
}
